import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"
import { AiOutlineBell } from "react-icons/ai";
import { FiInfo, FiUser, FiChevronDown } from "react-icons/fi";

//i18n
import { withTranslation } from "react-i18next"
// Redux
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import withRouter from "../../Common/withRouter"

// users
import user4 from "../../../assets/images/users/avatar-9.jpg"
import info from "../../../assets/images/symbols_info.png"

const ProfileMenu = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false)
  // Custom tooltip - the only place the signed-in user's name shows up.
  // Hidden once the dropdown itself is open, since it would otherwise sit
  // right behind the open menu.
  const [showTooltip, setShowTooltip] = useState(false)

  const [username, setusername] = useState("Admin")
  const [useremail, setuseremail] = useState("admin@gmail.com")

  useEffect(() => {
    const storedUsername = localStorage.getItem("userName")
    const storedUserEmail = localStorage.getItem("userEmail")
    if (localStorage.getItem("authUser")) {
      if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
        const obj = JSON.parse(localStorage.getItem("authUser"))
        setusername(obj.displayName)
      } else if (
        process.env.REACT_APP_DEFAULTAUTH === "fake" ||
        process.env.REACT_APP_DEFAULTAUTH === "jwt"
      ) {
        const obj = JSON.parse(localStorage.getItem("authUser"))
        if (obj.username) {

          setusername(obj.username)
        } else {
          setusername(obj.username)
        }
      }
    }

    setusername(storedUsername)
    setuseremail(storedUserEmail)
  }, [props.success])

  return (
    <React.Fragment>
      {/* Profile Dropdown - Only this should have dropdown functionality */}
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <div
          style={{ position: "relative" }}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          <DropdownToggle
            className="btn header-item waves-effect"
            id="page-header-user-dropdown"
            tag="button"
          >
            {/* A crisp vector avatar in the app's accent color, replacing the
                old low-res 32x32 profile.png placeholder, inside the same
                kq-icon-pill chrome shared with the language/notification/info
                icons so the whole row reads as one consistent control set. */}
            <div className="kq-icon-pill" style={{ width: "fit-content", paddingLeft: 6, paddingRight: 10 }}>
              <span
                style={{
                  width: 26,
                  height: 26,
                  borderRadius: "50%",
                  background: "linear-gradient(135deg, #F6255A, #FF7A59)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <FiUser size={14} color="#fff" strokeWidth={2.5} />
              </span>
              <FiChevronDown size={14} color="#fff" className="d-none d-xl-inline-block" />
            </div>
          </DropdownToggle>

          {/* Username tooltip - hovering the pill is the only way to see who
              you're signed in as without opening the dropdown, so this
              surfaces it right there rather than only inside the menu. */}
          {showTooltip && !menu && username && (
            <div
              role="tooltip"
              style={{
                position: "absolute",
                top: "calc(100% + 8px)",
                right: 0,
                background: "#21222d",
                border: "1px solid rgba(255,255,255,0.1)",
                borderRadius: 8,
                padding: "6px 12px",
                fontSize: 13,
                fontWeight: 600,
                color: "#fff",
                whiteSpace: "nowrap",
                boxShadow: "0 8px 20px rgba(0,0,0,0.35)",
                zIndex: 2001,
                pointerEvents: "none",
              }}
            >
              {username}
              <span
                style={{
                  position: "absolute",
                  top: -5,
                  right: 16,
                  width: 9,
                  height: 9,
                  background: "#21222d",
                  borderLeft: "1px solid rgba(255,255,255,0.1)",
                  borderTop: "1px solid rgba(255,255,255,0.1)",
                  transform: "rotate(45deg)",
                }}
              />
            </div>
          )}
        </div>
        <DropdownMenu className="dropdown-menu-end" style={{ zIndex: 2000 }}>
          {/* <DropdownItem tag="a" href="/profile/settings">
            {" "}
            <i className="uil uil-user-circle font-size-18 align-middle text-muted me-1"></i>
            {props.t("View Profile")}{" "}
          </DropdownItem> */}
          <DropdownItem tag="a" href="/profile/settings">
            <i className="uil uil-cog font-size-18 align-middle text-muted me-1"></i>
            {props.t("Settings")}
          </DropdownItem>
          <Link to="/feedback" className="dropdown-item">
            <i className="uil uil-comment-alt-lines font-size-18 align-middle text-muted me-1"></i>
            {props.t("Feedback")}
          </Link>
          <div className="dropdown-divider" />
          <Link to="/logout" className="dropdown-item">
            <i className="uil uil-sign-out-alt font-size-18 align-middle me-1 text-muted"></i>
            <span>{props.t("Logout")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  )
}

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
}

const mapStatetoProps = state => {
  const { error, success } = state.Profile
  return { error, success }
}

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
)
